import React, { useEffect, useState } from "react";
import { Container, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { apiGetProcesses } from "../../api/ApiProcess";
import ComponentBandeau from "../../components/layout/ComponentBandeau";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentSousmenu from "../../components/layout/ComponentSousmenu";
import ComponentSousTitle from "../../components/layout/ComponentSousTitle";
import ComponentTitle from "../../components/layout/ComponentTitle";
import BlocFiltreFakeInGovernance from "../../components/public/governance/BlocFiltreFakeInGovernance";
import { MdOutlineInfo } from "react-icons/md";
import BlocToggle from "../../components/layout/ComponentToggle";
import { chgGovernanceToggle, selectInGouvernanceToggle } from "../../redux/ReduxToggle";

const PageCartoProcess = () => {
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [loading, setLoading] = useState(false);
  const [processes, setProcesses] = useState([]);
  const [viewToggle, setViewToggle] = useState(useSelector(selectInGouvernanceToggle));
  const [anteriorite, setAnteriorite] = useState(31);
  const dispatch = useDispatch();
  //const [error, setError] = useState("");

  useEffect(() => {
    recupProcesses();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  const recupProcesses = async () => {
    setLoading(true);
    const res = await apiGetProcesses(
      ReduxInstance._id,
      "filter[famille]=MacroProcess&sort[ordre]=-1"
    );
    if (res) {
      setProcesses(res.data);
      setLoading(false);
    } else {
      setProcesses([]);
      //setError("Une erreur est survenue, veuillez réessayer ultérieurement");
      setLoading(false);
    }
  };

  const switchView = () => {
    dispatch(chgGovernanceToggle(!viewToggle));
    setViewToggle(!viewToggle);
  };

  return (
    <>
      <ComponentMenu menuActif="ingovernance" />
      <div className="containerHeaderBandeau">
        <ComponentBandeau menu="inGovernance" />
        <BlocToggle
          viewToggle={viewToggle}
          switchView={switchView}
          setAnteriorite={setAnteriorite}
          anteriorite={anteriorite}
          curseurInitial={1}
          max={5}
          min={0}
          disabled={true}
          sousMenus={ReduxInstance.sousMenus.filter((item) => item.parent === "inGovernance")}
        />
      </div>
      <BlocFiltreFakeInGovernance />
      {!loading && (
        <Container fluid>
          {/* <ComponentTitle title="Cartographie des processus" /> */}

          <div className="d-flex  cartoProcessContainer flex-column">
            {processes.map((process, key) => {
              return (
                <Link
                  className="m-1 p-4 macroProcessBloc d-flex align-items-center fw-bold"
                  to={"/processes/" + process._id}
                  key={process._id}
                >
                  <ComponentSousTitle nom={process.nom} />
                  <MdOutlineInfo className="text-end" size="1.5em" />
                </Link>
              );
            })}
          </div>
        </Container>
      )}
    </>
  );
};

export default PageCartoProcess;
